/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *
 *******************************************************************************/

import React from 'react' 
import TOS from '../../../components/Page/TOS'
 

const TOSPage = ()=> {
  
    return (
      <>
        <TOS />
      </>
    ) 
}
 
export default TOSPage
